import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=a217f302&scoped=true"
var script = {}
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=a217f302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a217f302",
  null
  
)

export default component.exports